/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import api from './api';
import { API_ENDPOINTS } from '../api/endpoints';

export const adminService = {
  getUsers: () => api.get(API_ENDPOINTS.ADMIN.USERS),
  banUser: (id: string | number) => api.post(API_ENDPOINTS.ADMIN.BAN_USER(id)),
  getItems: () => api.get(API_ENDPOINTS.ADMIN.ITEMS),
  approveItem: (id: string | number) => api.post(API_ENDPOINTS.ADMIN.APPROVE_ITEM(id)),
  getSettings: () => api.get(API_ENDPOINTS.ADMIN.SETTINGS),
  updateSettings: (data: any) => api.post(API_ENDPOINTS.ADMIN.SETTINGS, data),
};
